import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { useIsomorphicLayoutEffect } from '../../hooks';

/**
 * Компонента для отключения рендера на сервере
 * Умеет рендерить заглушку
 *
 * На клиенте в первом цикле рендера отрендерится fallback
 * После завершения первого цикла рендера,
 * сразу же стартует второй, при котором рендерится будет уже children
 *
 * ВНИМАНИЕ! Это не инструмент для разделения кода!
 *
 * @export
 * @param {INoSsrProps} { children, fallback, defer }
 * @returns
 */
export function NoSsr(_ref) {
  var children = _ref.children,
      fallback = _ref.fallback,
      defer = _ref.defer;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isMounted = _React$useState2[0],
      setIsMounted = _React$useState2[1];

  useIsomorphicLayoutEffect(function () {
    if (!defer) {
      setIsMounted(true);
    }
  }, []);
  React.useEffect(function () {
    if (defer) {
      setIsMounted(true);
    }
  }, []);

  if (isMounted) {
    return children;
  }

  return fallback || null;
}